<app-list
  class="list"
  [items]="basemapItems"
  [vertical]="!isMobileScreen"
  [horizontal]="!!isMobileScreen"
>
  <ng-template listContainer let-itemListTemplate="itemListTemplate">
    <div class="content">
      <div class="container-fluid">
        <div class="row gy-4" [ngClass]="isMobileScreen && 'mobile-mode'">
          <ng-template [ngTemplateOutlet]="itemListTemplate"></ng-template>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template listItem let-item="item" let-index="index">
    <div class="col-{{ isMobileScreen ? 'auto' : 'md-6' }}">
      <div
        class="basemap-item"
        [ngClass]="{ selected: selectedIndex === index }"
      >
        <div class="img-container" (click)="onBasemapItemClick(item, index)">
          <img class="img" [src]="item.imageUrl ?? defaultBasemapImageUrl" />

          <div class="mask"></div>
        </div>

        <span class="text">{{ item.text }}</span>
      </div>
    </div>
  </ng-template>
</app-list>
